document.addEventListener('algolia.hooks.initialize', function () {

  // AUTOCOMPLETE
  algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', function(options) {
    // Change the placeholder text of the autocomplete menu
    options.placeholder = window.algolia.placeholder_autocomplete
    return options;
  });

  algoliaShopify.hooks.registerHook('beforeAutocompleteCollectionsTemplate', function(_defaultTemplate, templateOptions, itemLink) {

    const { html, item, components } = templateOptions;

    const isAlgoliaIgnore =  item.meta?.clrz?.algolia_ignore ? item.meta?.clrz?.algolia_ignore : false

    if (isAlgoliaIgnore) return
    return  html`
      <a href="${itemLink}" class="aa-ItemLink">
        <div class="aa-ItemWrapper">
          <div class="aa-ItemContent">
            <div class="aa-ItemIcon aa-ItemIcon--noBorder">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
                />
              </svg>
            </div>
            <div class="aa-ItemContentBody">
              <div class="aa-ItemContentTitle">
                ${components.Highlight({ hit: item, attribute: 'title' })}
              </div>
            </div>
          </div>
        </div>
      </a>
    `;
  });

  algoliaShopify.hooks.registerHook("beforeAutocompleteProductTemplate",
    function (_defaultTemplate, templateOptions, distinct, itemLink, trackSearchAttribution) {

      const {
        html,
        item,
        components
      } = templateOptions;

      const itemImage = algoliaShopify.helpers.renderImage(item, 140);
      return html`
        <a
          href="${itemLink}"
          class="aa-ItemLink aa-ProductItem"
        >
          <div class="aa-ItemContent" style="1px solid red">
            <div class="aa-ItemPicture aa-ItemPicture--loaded">
              <img
                src="${itemImage.src}"
                srcset="${itemImage.srcset}"
                sizes="${itemImage.sizes}"
                alt="${item.title}"
              />
            </div>
            <div class="aa-ItemContentBody">
              <div class="aa-ItemContentBrand">
                ${item.product_type &&
            components.Highlight({ hit: item, attribute: "product_type" })
            }
              removing vendor
              </div>
              <div class="aa-ItemContentTitleWrapper">
                <div class="aa-ItemContentTitle">
                  ${components.Highlight({ hit: item, attribute: "title" })}
                </div>
              </div>
              <div class="aa-ItemContentPrice">
                <div class="aa-ItemContentPriceCurrent">
                    <b>${algoliaShopify.helpers.displayPrice(item, distinct)}</b> 
                    ${distinct && item.compare_at_price != 0 &&
                      html`
                        <span class="ais-hit--price-striked"
                          ><span
                            >${algoliaShopify.helpers.displayStrikedPrice(
                            item.price,
                            item.compare_at_price
                          )}</span
                          ></span
                        >
                      `}
                </div>
              </div>
            </div>
          </div>
        </a>
      `;
    }
  );
  algoliaShopify.hooks.registerHook('beforeAutocompleteFooterTemplate', function(_defaultTemplate, templateOptions) {
    const { html, state } = templateOptions;
    return html`
      <div class="aa-footer" style="text-align: left !important;">
        <a
          class="aa-SeeAllBtn"
          class="t-button t-button--black u-text-white"
          href="${window.Shopify.routes.root}search?q=${state.query}"
        >
          ${algoliaShopify.translations.allProducts}
          (${algoliaShopify.helpers.formatNumber(state.context.nbProducts)})
        </a>
      </div>
    `;
  });

  algoliaShopify.hooks.registerHook('beforeAutocompleteMainTemplate', function(_defaultTemplate, templateOptions, elements, displaySuggestions) {
    const { html } = templateOptions;

    return html`
    <div class="u-h-full u-w-full u-relative">
    <div class="aa-PanelLayout aa-Panel--scrollable">
      <div class="aa-PanelSections">
        <div class="aa-PanelSection--left">
          ${displaySuggestions &&
            html`
              <div class="aa-SourceHeader">
                <span class="aa-SourceHeaderTitle"
                  >${algoliaShopify.translations.suggestions}</span
                >
                <div class="aa-SourceHeaderLine" />
              </div>
              ${elements.querySuggestionsPlugin}
            `}
          ${elements.collections} ${elements.articles} ${elements.pages}
            ${elements.redirectUrlPlugin}

          </div>
          <div class="aa-PanelSection--right u-flex u-flex-col u-justify-between u-items-start">
          ${elements.products}
          </div>
          </div>
         
          </div>
    </div>
  `;
  })

  algoliaShopify.hooks.registerHook('beforeAutocompleteNoResultsTemplate', function(_defaultTemplate, templateOptions) {
    const { html, state } = templateOptions;

    return html`
      <div class="aa-PanelLayout aa-Panel--scrollable">
        <p class="aa-NoResultsHeader">
          ${window.algolia.no_results_autocomplete} <b>${state.query}</b>
        </p>
       <div class="aa-NoResultsHeader-suggestions">${window.algolia.no_results_suggestions}</div>
       <div class="u-flex u-flex-wrap u-items-center" style="margin-bottom: 20px !important">
        ${window.algolia.collections_no_results.map(coll => 
          html`
            <a href="${coll.link}" class="t-button t-button--grey-extra-light t-button--xs u-text-black" style="margin-right: 5px !important; margin-bottom: 5px !important; font-size: 12px !important">
              <div>${coll.title}</div>
            </a>
          `
      )}
       </div>
        <a class="aa-NoResultsLink u-inline-block" href="${window.Shopify.routes.root}search?q=">
         <div class="t-button t-button--black t-button--lg  u-text-white">${algoliaShopify.translations.allProducts}</div>
        </a>
      </div>
    `;
  });

  // INSTANT SEARCH
  algoliaShopify.hooks.registerHook('beforeInstantSearchStatsTemplate', function(_defaultTemplate, data, html) {
    if (window.location.pathname.includes('/collections/')) return
    return html`
      ${data.hasOneResult &&
        html`
          <span class="ais-stats--nb-results">
            ${window.algolia.result} "${data.query}"
          </span>
        `}
      ${data.hasManyResults &&
        html`
          <span class="ais-stats--nb-results">
            ${' '} ${algoliaShopify.helpers.formatNumber(data.nbHits)} ${' '}
            ${window.algolia.results} "${data.query}"
          </span>
        `}
    `;
  });

  //Changement template pour nouveau currentRefinement widget
  algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function (_defaultTemplate, data, html) {
    document.body.classList.add('hits-loaded')
    return html`
      <div class="ais-page">
        <h1 class="ais-h2">${algoliaShopify.translations.searchTitle}</h1>
        <div data-hide-element class="ais-input">
          <div class="ais-search-box-container"></div>
          <div class="ais-input-button">
            <div class="ais-clear-input-icon"></div>
          </div>
        </div>
        <div class="clrz-facets-button">
          <div class=" t-button t-button--orange u-bg-orange before:u-opacity-0 u-items-center u-justify-center" style="display: flex !important">
            <span class="wording-content ais-facets-button">${window.algolia.show_filters}</span>
            <div class="count-filters"></div>
          </div>
        </div>
        <div class="ais-facets">
          <div class="ais-clear-refinements-container"></div>
          <div class="ais-current-refined-values-container" style="display:none"></div>
          <div class="ais-current-refined-values-container2 t-text"></div>
          ${data.facets.map(
      facet =>
        html`
                <div
                  class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}"
                >
                  <label
                    for="${facet.escapedName}"
                    class="ais-range-slider--header ais-facet--header ais-header"
                    >${facet.title}</label
                  >
                  <input
                    class="ais-dropdown-checkbox"
                    type="checkbox"
                    id="${facet.escapedName}"
                    name="dropdown"
                  />
                  <div
                    class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"
                  ></div>
                </div>
              `
    )}
        </div>
        <div class="ais-block">
          <div class="ais-search-header">
            <div class="ais-stats-container"></div>
            <div class="ais-change-display">
              <span class="ais-change-display-block ais-change-display-selected"
                ><i class="fa fa-th-large"></i
              ></span>
              <span class="ais-change-display-list"
                ><i class="fa fa-th-list"></i
              ></span>
            </div>
            <div class="ais-sort">
              ${data.multipleSortOrders
        ? html`
                    ${algoliaShopify.translations.sortBy}
                    <span class="ais-sort-orders-container"></span>
                  `
        : html`
                    ${algoliaShopify.translations.sortBy}
                    ${algoliaShopify.translations.relevance}
                  `}
            </div>
          </div>
          <div class="ais-hits-container ais-results-as-block"></div>
        </div>
        <div class="ais-pagination-container"></div>
      </div>
    `;
  });

  algoliaShopify.hooks.registerHook('beforeInstantSearchNoResultTemplate', function(_defaultTemplate, html) {
    document.querySelector('.ais-pagination-container').style.display = "none"
    document.querySelector('.ais-facets').style.display = 'none'
    document.querySelector('.ais-search-header').style.display = 'none'
    document.querySelector('.ais-block').style.display = "block"
    document.querySelector('.ais-block').style.gridColumn = "span 12/ span 12"
    
    return html`
      <div class="ais-hit-empty">
        <div class="ais-hit-empty--title">
         ${window.algolia.no_results_instant_search}
        </div>
        <div class="ais-hit-empty--clears">
           <a class="aa-NoResultsLink u-inline-block" href="${window.Shopify.routes.root}search?q=">
            <div class="t-button t-button--black t-button--lg u-text-white">${algoliaShopify.translations.allProducts}</div>
          </a>
        </div>
      </div>
    `;
  });

  algoliaShopify.hooks.registerHook('beforeInstantSearchFacetParamsOptions', function (params, facet) {

    if (facet.name === 'meta.fmsync.ssfamille') {
      params = {
        ...params,
        templates: {
          item(item, { html }) {
            const { url, label, count, isRefined, cssClasses } = item;
            return html`
              <label class="${cssClasses.label} flex items-center">
              ${(isRefined ? html`
                    <input
                      type="checkbox"
                      class="${cssClasses.checkbox}"
                      checked
                    />
                  `
                : html`
                    <input type="checkbox" class="${cssClasses.checkbox}" />
                  `)}
               
                ${label}
                <span class="${cssClasses.count}">${count}</span>
              </label>
            `;
          },
        },

      }
    }
    if (facet.name === 'options.taille') {
      params = {
        ...params,
        templates: {
          item(item, { html }) {
            const { url, label, count, isRefined, cssClasses } = item;
            return html`
              <label class="${cssClasses.label} flex items-center">
              ${(isRefined ? html`
                    <input
                      type="checkbox"
                      class="${cssClasses.checkbox}"
                      checked
                    />
                  `
                : html`
                    <input type="checkbox" class="${cssClasses.checkbox}" />
                  `)}
               
                ${label}
                <span class="${cssClasses.count}">${count}</span>
              </label>
            `;
          },
        },
        transformItems(items, { results }) {
          // Ordre des tailles
        const orderedSizes = [
          "18/24 MOIS",
          "5/6 ANS",
          "6/7 ANS",
          "7/8 ANS",
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "XXL"
        ];
        // Fonction de tri
          items.sort((a, b) => {
            return orderedSizes.indexOf(a.value) - orderedSizes.indexOf(b.value);
          });
          return items
        },
      }
    }
    
    if (facet.name === "price_ratio") {
      params = {
        ...params,

        templates: {
          item(item, { html }) {
            const { url, label, count, isRefined, cssClasses } = item;
            return html`
              <label class="${cssClasses.label} flex items-center">
              ${(isRefined ? html`
                    <input
                      type="checkbox"
                      class="${cssClasses.checkbox}"
                      checked
                    />
                  `
                : html`
                    <input type="checkbox" class="${cssClasses.checkbox}" />
                  `)}
               
                ${label}
                <span class="${cssClasses.count}">${count}</span>
              </label>
            `;
          },
        },

        transformItems(items, { results }) {
          const isPromoRefined = results.facets.stats?.price_ratio[0] == -1 || false;

          //il y a un risque de ne pas être exhaustif si bcp de valeurs
          const promoCount = items.reduce((accumulator, currentValue) => {
            return parseFloat(currentValue.value) < 1 ? accumulator + 1 : accumulator;
          }, 0)

          //si aucune option promp (pas de valeur < 1)
          if (promoCount === 0) {
            return [];
          }

          return [{
            count: promoCount,
            isRefined: isPromoRefined,
            isExcluded: false,
            value: "-1",
            label: window.algolia.product_promotion
          }]
        },


      }

    }

    const colorMap = {
      'BLEU': '#0843FF',
      'ROUGE': '#FF0808',
      'NOIR': '#000000',
      'JAUNE': '#F7E800',
      'MARINE': '#043E9F',
      'GRIS': '#C1C1C1',
      'VERT': '#08F50B',
      'KAKI': '#F0E68C',
      'MARRON': '#582900',
      'BEIGE': '#F5F5DC',
      'BORDEAUX': '#800000',
      'BLANC': '#FFFFFF',
      'ROSE': '#FD6C9E',
      'ORANGE': '#FF8000',
      'OR': '#FFD700',
      'BLANCHE/ INDIGO': '#FFFFFF',
      'BLANC/GRIS': '',
      'BLEU/VERT': '',
      'BLUE/YELLOW': '#0843ff',
      'NOIR/KAKI': '#f0e68c',
      'BLACK/GRAPHITE GREY': '#000000'
    }

    function splitAndDeduplicateColors(arr) {
      const seen = new Set();
      const result = [];
    
      arr.forEach(item => {
        if (item.value.includes('/')) {
          // Split la valeur et crée des objets séparés
          const parts = item.value.split('/').map(s => s.trim());
          parts.forEach(part => {
            const valUpper = part.toUpperCase();
            if (!seen.has(valUpper)) {
              seen.add(valUpper);
              result.push({
                ...item,
                value: part,
                label: part,
                highlighted: part
              });
            }
          });
        } else {
          const valUpper = item.value.toUpperCase();
          if (!seen.has(valUpper)) {
            seen.add(valUpper);
            result.push(item);
          }
        }
      });
    
      return result;
    }

    
    if (facet.name == "meta.filters.color") {
      // Personnalisation des couleurs dans le menu de facettes
      return {
        ...params,
        transformItems(items, { results }) {
          const newData = splitAndDeduplicateColors(items);
          return newData
        },
        templates: {
          ...params.templates,
          item(item, {
            html
          }) {
            const {
              label
            } = item;
            
            const colorBg = colorMap[label.toUpperCase()] || label.toUpperCase();
            const labelHandlelize = label.replace(/[^A-Z0-9]/ig, "");

            return html`
              <label class="ais-RefinementList-label ais-facet--label ais-facet--label-color">
                <div class="ais-facet--label-color-preview ais-facet--label-color-preview--${labelHandlelize}" style="background-color:${colorBg};"></div>
              </label>
            `;
          },
        },
      };
    }

    return {
      ...params
    };
  });

  //Nouveau current Refinement pour prise en charge Promo
  algoliaShopify.hooks.registerHook('beforeISStartAddWidgetArray', function () {

    const connectCurrentRefinements =
    window.algoliaShopify.externals.connectors.connectCurrentRefinements;
    const panel = window.algoliaShopify.externals.widgets.panel;
  

    const createDataAttributes = refinement => {
      return Object.keys(refinement)
        .map(function (key) {
          if (refinement.attribute === "price_ratio" && key == 'value') {
            return `data-${key}="${refinement[key].replace('\\', '')}"`;
          } else {
            return `data-${key}="${encodeURIComponent(refinement[key] || '')}"`;
          }
        })
        .join(' ');
    };

    const renderListItem = function (item) {
      const facet = window.algoliaShopify.instantsearch.facets.list.find(function (f) {
        return f.name === item.label;
      });
      const test = item.refinements
        .map(function (refinement) {
          if (facet.name === "price_ratio") {
            return `<li class="ais-current-refined-values--item">
                  <a ${createDataAttributes(refinement)} class="ais-current-refined-values--link">
                    <div class="t-text u-text-13">
                      <div class="ais-current-refined-values--label u-font-bold u-text-orange">
                        ${window.algolia.product_promotion}
                      </div>
                    </div>
                  </a>
                </li>`;
          }

          if (facet.name === "price_range") {
            // Reformater refinement.label pour afficher une fourchette de prix lisible
            const formattedLabel = refinement.label.replace(":", " - ") + " " + window.currency;

            return `<li class="ais-current-refined-values--item">
                  <a ${createDataAttributes(refinement)} class="ais-current-refined-values--link">
                    <div class="t-text u-text-orange u-text-13">
                           <div class="ais-current-refined-values--label u-font-bold ">${facet.title
              }</div> : ${formattedLabel}
                    </div>
                  </a>
                </li>`;
          }

          return `<li class="ais-current-refined-values--item">
              <a ${createDataAttributes(refinement)} class="ais-current-refined-values--link">
                <div class="t-text u-text-13">
                  <div class="ais-current-refined-values--label">${facet.title
            }</div>
                      : ${refinement.label}
                </div>
              </a>
            </li>`;
        })
        .join('');

      return test
    };

    const renderCurrentRefinements = function (renderOptions) {
      const items = renderOptions.items;
      const refine = renderOptions.refine;
      const widgetParams = renderOptions.widgetParams;

     const filtersCount = items.map(el => el.refinements).flat()

      const countFilterElInBtn = document.querySelector('.count-filters')
      if (countFilterElInBtn) {
          countFilterElInBtn.innerHTML = filtersCount.length === 0 
            ? '' 
            : `(${filtersCount.length})`
        
      }

      widgetParams.container.innerHTML = `
        <div class="ais-current-refined-values--header ais-facet--header ais-header u-w-fit">
          ${algoliaShopify.translations.selectedFilter}
        </div>
        <div class="ais-root ais-current-refined-values ais-facet">
          <ul class="ais-current-refined-values--list">
            ${items.map(renderListItem).join('')}
          </ul>
        </div>`;

      Array.prototype.slice
        .call(
          widgetParams.container.querySelectorAll(
            '.ais-current-refined-values--link'
          )
        )
        .forEach(function (element) {
          element.addEventListener('click', function (event) {
            const item = Object.keys(event.currentTarget.dataset).reduce(function (
              acc,
              key
            ) {
              const itemData = {};
              itemData[key] = decodeURIComponent(
                event.currentTarget.dataset[key]
              );
              return window.algoliaShopify.assign({}, acc, itemData);
            }, {});


            refine(item);
          });
        });
    };

    // Create the custom widget
    const customCurrentRefinements = connectCurrentRefinements(
      renderCurrentRefinements
    );

    const hasRefinements = function (helper, facetsList) {

      return facetsList.some(function (f) {
        const isConjunctiveFacetRefined =
          helper.state.isConjunctiveFacet(f.name) &&
          helper.state.isFacetRefined(f.name);
        const isDisjunctiveFacetRefined =
          helper.state.isDisjunctiveFacet(f.name) &&
          helper.state.isDisjunctiveFacetRefined(f.name);
        const isHierarchicalFacetRefined =
          helper.state.isHierarchicalFacet(f.name) &&
          helper.state.isHierarchicalFacetRefined(f.name);

        const numericRefinements = helper.state.getNumericRefinements(f.name);
        const isNumericFacetRefined = Object.keys(numericRefinements).some(
          function (operator) {
            return numericRefinements[operator].length > 0;
          }
        );

        return (
          isNumericFacetRefined ||
          isConjunctiveFacetRefined ||
          isDisjunctiveFacetRefined ||
          isHierarchicalFacetRefined
        );
      });
    };

    const customCurrentRefinementsWithPanel = panel({
      hidden: options => {
        return !hasRefinements(options.helper, window.algoliaShopify.instantsearch.facets.list);
      },
    })(customCurrentRefinements);

    const widget = customCurrentRefinementsWithPanel({
      container: '.ais-current-refined-values-container2'

    });


    const widgetFacetButton = {
      init: () => {
        const $button = document.querySelector('.ais-facets-button')
        const $wording = document.querySelector('.wording-content')
        ;
        $button.addEventListener(
          'click',
          function () {
            const $facets = document.querySelector('.ais-facets');
            if ($facets.classList.contains('ais-facets__shown')) {
              $wording.textContent = window.algolia.hide_filters;
            } else {
              $wording.textContent = window.algolia.show_filters;
            }
          },
          { passive: true }
        );
      },
    }

    return [widget, widgetFacetButton];

  });

  
  let productRenderCount = 0;

  algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function (_defaultTemplate, hit, html, components) {

    productRenderCount++;
    const pushes = window.collectionPushes || [];
    const pushHtml = (html, push) => html`
  <div class="push-collection push-collection-${productRenderCount}">
    <article class="c-card-push-collection | u-relative | u-overflow-hidden | u-h-full">
      <figure class="u-relative | u-h-full">
        <picture class="u-w-full u-h-full u-inline-block" >
          <source media="(max-width: 767px)" data-srcset="${push.image_mobile}" srcset="${push.image_mobile}" />
          <source data-srcset="${push.image}" srcset="${push.image}" />
          <img srcset="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" data-src="${push.image}" src="${push.image}" class="u-w-full u-h-full u-object-cover lazyload" alt="${push.title}" />
        </picture>
      </figure>
      <header class="u-absolute u-bottom-0 u-left-0 __content u-flex u-items-end u-justify-start u-h-full u-w-full">
        <div class="u-w-full u-p-20">
            ${push.title
        ? html`<h2 class="t-h2 u-mb-0 u-uppercase u-text-white ">${push.title}</h2>`
        : ''}
            
            ${push.subtitle
        ? html`<p class="u-mb-20 u-text-white subtitle">${push.subtitle}</p>`
        : ''}
            
            ${push.url
        ? html`
                  <a href="${push.url}" class="button | u-inline-block | u-extend-href">
                    <span>${push.ctaLabel}</span>
                  </a>
                `
        : ''}
        </div>
      </header>
    </article>
  </div>
`;

    if (productRenderCount === 5 && pushes[0]) {
      return html`${html} ${pushHtml(html, pushes[0])}`;
    }

    if (productRenderCount === 14 && pushes[1]) {
      return html`${html} ${pushHtml(html, pushes[1])}`;
    }

    const hitImage = algoliaShopify.helpers.renderImage(hit, 400);

    const metaVariantsColorz = hit.meta?.product?.variants_colors ? JSON.parse(hit.meta?.product?.variants_colors) : null
    const metaCustomizable = hit.meta?.product?.customization_products ? JSON.parse(hit.meta?.product?.customization_products) : null
    const metaBanner = hit.meta?.product?.mini_banner ? hit.meta?.product?.mini_banner : null
    const metaDiscounts = hit.meta.filter?.discount ? JSON.parse(hit.meta.filter.discount) : null

    const tagsToDiplay = hit.tags.filter(tag => tag.toLowerCase().includes('tag_')).map(el => el.toLowerCase().split('tag_')[1])

    return html`
    <a href="${algoliaShopify.helpers.instantsearchLink(hit)}">
      <div
        class="ais-hit ais-product u-relative c-card-product__body"
        data-algolia-index="${hit.index}"
        data-algolia-position="${hit.productPosition}"
        data-algolia-queryid="${hit.queryID}"
        data-algolia-objectid="${hit.objectID}"
        data-handle="${hit.handle}"
        data-variant-id="${hit.objectID}"
        data-distinct="${hit._distinct}"
        data-product-id="${hit.id}"
      >

        <div class="u-relative u-overflow-hidden">
        ${metaDiscounts ? html`
          <div class="c-card-product__badge | u-z-[1] u-absolute u-top-10 u-left-10 lg:u-top-15 lg:u-left-15">
            ${metaDiscounts.map(el => html`<span class="t-badge | u-bg-white">${el}%</span>`)}
          </div>
        ` : ''}
          ${metaCustomizable ? html`
            <div class="c-card-product__badge | u-absolute u-top-15 u-left-15">
              <span class="t-badge | u-bg-white">personnalisable</span>
            </div>
        ` : ''}
          ${metaBanner ? html`
          <div class="c-card-product__band | u-z-[1] u-absolute u-bottom-0 u-left-0 | u-flex u-justify-center u-items-center | u-w-full | !u-p-10 | u-bg-white-65">
            ${metaBanner}
          </div>
        ` : ''}
            <div data-variants class="u-absolute u-w-full u-bg-white u-top-auto u-bottom-0 u-left-0 u-z-[1]">
            </div>

            <div class="u-absolute u-top-10 u-right-10 lg:u-top-15 lg:u-right-15 u-z-[2]"></div>

          <div class="ais-hit--picture-wrapper ">
            <div class="u-w-full u-object-cover">
              <img
                class="ais-hit--picture"
                src="${hitImage.src}"
                srcset="${hitImage.srcset}"
                sizes="${hitImage.sizes}"
                alt="${hit.title} - ${hit.variant_title}"
              />
            </div>
          </div>
          <div data-hidden-pictures class="u-absolute u-top-0 | u-w-full"></div>

          ${!hit._distinct && hit.compare_at_price != 0 &&
            html`
            <span class="ais-hit--price-discount u-absolute u-top-10 u-left-10 lg:u-top-15 lg:u-left-15">
              <span class="t-badge | u-bg-white">${algoliaShopify.helpers.displayDiscount(
                hit.price,
                hit.compare_at_price,
                hit.price_ratio
              )}</span>
            </span>
          `}
        </div>

        <div class="ais-hit--details-clrz">
            <div class="u-flex u-justify-between u-items-center">
              ${tagsToDiplay.map(tag => html`
                <p style="margin-bottom: 5px !important;">
                    <span class="u-text-orange u-font-sans u-font-bold u-uppercase" style="font-size: 11px">${tag}</span>
                  </p>
              `)}
            </div>
          <p class="ais-hit--title">
            <a
              data-algolia-index="${hit.index}"
              data-algolia-position="${hit.productPosition}"
              data-algolia-queryid="${hit.queryID}"
              data-algolia-objectid="${hit.objectID}"
              data-disctinct="${hit._distinct}"
              href="${algoliaShopify.helpers.instantsearchLink(hit)}"
              title="${algoliaShopify.helpers.fullTitle(
                hit.title,
                hit._distinct,
                hit.variant_title
              )}"
            >
              ${components.Highlight({ attribute: 'title', hit })}
            </a>
          </p>
          <p class="ais-hit--title">${metaVariantsColorz ? 
              `${metaVariantsColorz.length} ${window.algolia.colors}` :
            `1  ${window.algolia.color}`}
          </p>
          <p class="ais-hit--price">
            <b>${algoliaShopify.helpers.displayPrice(hit, hit._distinct)}</b> 
            ${hit._distinct && hit.compare_at_price != 0 &&
              html`
                <span class="ais-hit--price-striked"
                  ><span
                    >${algoliaShopify.helpers.displayStrikedPrice(
                    hit.price,
                    hit.compare_at_price
                  )}</span
                  ></span
                >
              `}
          </p>
        </div>
      </div>
      </a>
    `;
  });


});


// 1. La fonction qui met à jour chaque hit
async function fetchVariants(handle, hitEl) {
  const fetchUrl = new URL(window.location);
  const lang = document.documentElement.lang;
  if (lang === 'fr') {
    fetchUrl.pathname = `/products/${handle}`;
  } else {
    fetchUrl.pathname = `/${lang}/products/${handle}`;
  }  
  fetchUrl.searchParams.append('section_id', 'card-product');

  const res = await fetch(fetchUrl).then(r => r.text());
  const parser = new DOMParser();
  const dom = parser.parseFromString(res, 'text/html');

  const dataVariantsEl  = hitEl.querySelector('[data-variants]');
  const dataHiddenPictures  = hitEl.querySelector('[data-hidden-pictures]');

  const newContent  = dom.querySelector('[data-variants-size-color]');
  const hiddenPictures = dom.querySelector('[data-hidden-pictures]');

  if (dataVariantsEl && newContent) dataVariantsEl.innerHTML = newContent.innerHTML;
  if (dataVariantsEl && hiddenPictures) dataHiddenPictures.innerHTML = hiddenPictures.innerHTML;
}

// 2. WeakSet pour marquer les hits déjà traités
const processedHits = new WeakSet();

// 3. IntersectionObserver pour ne lancer fetchVariants que quand le hit devient visible
const io = new IntersectionObserver((entries, observer) => {
  entries.forEach(async entry => {
    if (entry.isIntersecting) {
      const el = entry.target;
      if (!processedHits.has(el)) {
        processedHits.add(el);
        await fetchVariants(el.dataset.handle, el);
        document.dispatchEvent(
          new CustomEvent('revive:CardProductHover', {
            detail: { container: el.parentNode },
          }),
        )
      }
      observer.unobserve(el);
    }
  });
}, {
  root: null,      // viewport
  threshold: 0.1   // déclenche quand 10% de l'élément est visible
});

// 4. Observer tous les hits existants
document.querySelectorAll('.ais-hit').forEach(el => {
  io.observe(el);
});

// 5. MutationObserver pour détecter les nouveaux hits et le panel "Voir tout"
const observer = new MutationObserver(mutations => {
  for (const { addedNodes } of mutations) {
    addedNodes.forEach(node => {
      if (node.nodeType !== Node.ELEMENT_NODE) return;
      // a) Si c’est une nouvelle hit
      if (node.matches('.ais-hit')) {
        io.observe(node); 
      }
      else {
        node.querySelectorAll('.ais-hit').forEach(el => {
          io.observe(el);
        });
      }
    
  
   
    });
  }
});

// 6. Lancement de l’observation du DOM
observer.observe(document.body, {
  childList: true,
  subtree:   true
});
